module.exports = __webpack_public_path__ + "content-c460a45d997b45239190.png";